import { Loader } from "@trackman/web-shared-components";
import AppSpacer from "./AppSpacer";

export const AppLoader = (
    {
        children,
        isShowingLoader,
        loaderSize,
        spacing = 10
    }:
        {
            children: React.ReactNode;
            isShowingLoader?: boolean;
            loaderSize?: 'small' | 'large'
            spacing?: number
        }) => {
    return (
        <div className='d-flex'>
            {isShowingLoader && <Loader size={loaderSize} />}
            <AppSpacer space={`${spacing}px`} />
            {children}
        </div>
    );
};

export default AppLoader;